import { Card } from 'antd';
import { FC, memo, useCallback, useState } from 'react';

import { ReferralLinksOverviewView } from './ReferralLinksOverviewView';

interface Props {
  referralId: string;
  siteId: string;
}

export const ReferralLinksOverviewContainer: FC<Props> = memo(({ referralId, siteId }) => {
  const [isEditingList, setIsEditingList] = useState(false);

  const handleSetEditingListMode = useCallback((is?: true): void => {
    setIsEditingList(is || false);
  }, []);

  return (
    <Card>
      <ReferralLinksOverviewView
        referralId={ referralId }
        siteId={ siteId }
        isEditingList={ isEditingList }
        handleSetEditingListMode={ handleSetEditingListMode }
      />
    </Card>
  );
});
